import { render } from "./SearchStorage.vue?vue&type=template&id=6c92553e&scoped=true"
import script from "./SearchStorage.vue?vue&type=script&lang=js"
export * from "./SearchStorage.vue?vue&type=script&lang=js"

import "./SearchStorage.vue?vue&type=style&index=0&id=6c92553e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c92553e"]])

export default __exports__